import {
  OrderSelectionOptionItem,
  OrderStatusCode,
  ROLE,
} from '../../interface/interface';

export const handleShippedStatus = (
  groups: unknown,
  allOrderStatus: OrderSelectionOptionItem[],
  commonAdminStatuses: OrderStatusCode[],
) => {
  if ([ROLE.Admin, ROLE.Pharmacist].includes((groups as string[])[0] as ROLE)) {
    return allOrderStatus.filter((e) => commonAdminStatuses.includes(e?.id));
  } else {
    return [];
  }
};
